import { render } from "./LocationLogo.vue?vue&type=template&id=1420f9b2&scoped=true"
import script from "./LocationLogo.vue?vue&type=script&lang=js"
export * from "./LocationLogo.vue?vue&type=script&lang=js"

import "./LocationLogo.vue?vue&type=style&index=0&id=1420f9b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1420f9b2"]])

export default __exports__